export default ({ time }) => [
  {
    title: 'Дата и время', value: time.fontFamily1, paramName: 'fontFamily1', parentName: 'time',
  },
  {
    title: 'Текст', value: time.fontFamily2, paramName: 'fontFamily2', parentName: 'time',
  },
];
